// Single source of truth for the user-facing Score label.
// Postmenopause users see "Vitality Score"; everyone else sees
// "Menopause Impact Score". The underlying score math/storage is
// identical — only the label varies.
export function getScoreLabel(
  stage: string | null | undefined,
): "Vitality Score" | "Menopause Impact Score" {
  return stage === "Postmenopause" ? "Vitality Score" : "Menopause Impact Score";
}
